import React from 'react'

interface ProfileDropdownUserProps {
  width?: number
  height?: number
  color?: string
}

export const ProfileDropdownUser = ({
  width,
  height,
  color = 'var(--color-main-dark)',
}: ProfileDropdownUserProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 12C14.25 12 16.0499 10.2 16.0499 7.95005C16.0499 5.70005 14.25 4.05005 12 4.05005C9.74995 4.05005 7.94995 5.85005 7.94995 7.95005C7.94995 10.05 9.74995 12 12 12Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 21V19.05C6 18 6.45 16.95 7.2 16.2C7.95 15.45 9 15 10.05 15H14.1C15.15 15 16.2 15.45 16.95 16.2C17.7 16.95 18.15 18 18.15 19.05V21H6Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
